<template>
	<el-row class="container">
    <!-- ------------------------------- TOP ROW ------------------------------- -->		
		<el-col :span="24" class="header">
			<el-col :span="10" v-if="showMiniMenu || !collapsed" class="logo" :class="collapsed?'logo-collapse-width':'logo-width' + ' ' + stageClass"
			        :title='versionInfo()' i>
				<!--<img style='margin-left:-10px;height:35px;width:35px;' src='../../static/img/logo-261-213.jpg'> </img>-->
 				<img style='margin-left:-10px;height:35px;width:35px;border-radius:2px' src='../../static/img/tuilogo.png'> </img>
				{{collapsed?'':"Tui-WRD-Services" + this.stageSubtitle}}
			</el-col>
			<el-col :span="10">        
        <div class="tools" xclick.prevent="collapse" style='width:450px'>
          <!-- Hamburger menu -->
          <span @click.prevent="collapse">
            <span style='margin-left:-10px;margin-top:2px;float:left'><i class='el-icon-menu' style='font-size:20px'></i></span>
          </span>
          <!--
          <span> < !-- Media Player!! -- >           
             <audio ref='audio' id="audio-player" type="audio/mp3" controls="controls" 
                 controlsList="nodownload noplaybackrate" class='player' style='float:left;margin-right:10px' autoplay></audio>                      
          </span>
          <caption style='display:none' ref='current-song' id='current-song' />          
          -->
        </div>
      </el-col>

      <el-col :span="4" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner"><img :src="this.sysUserAvatar" /> {{this.sysUserName}}</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="openPage('/shownews')">News</el-dropdown-item>
						<el-dropdown-item @click.native="openPage('/profile')">Profile</el-dropdown-item>  
  					<el-dropdown-item divided @click.native="logout">Logout</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
	
    <!-- ------------------------------- LINKER MENU ------------------------------- -->		
		<el-col :span="24" class="main">
      
          <aside id="sidemenu" v-if="showMiniMenu || !collapsed" :class="collapsed?'menu-collapsed':'menu-expanded'">
				<!-- NavigatieMenu -->
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed">
					<el-menu-item index="" class='topitem' @click.native="openPage('/main')">
            <li class='el-icon-s-home'></li> Home
          </el-menu-item>
					
          <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden && canUse(item)">
						<el-submenu :index="index+''" v-if="!item.leaf && canUse(item)">
							<template slot="title">
                <i :class="item.iconCls"></i>{{item.name}}
              </template>
							<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" 
							              v-if="!child.hidden && canUse(child)">{{child.name}}
              </el-menu-item>
						</el-submenu>
						<!--
            <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
              <i :class="item.iconCls"></i>{{item.children[0].name}}
            </el-menu-item>
            -->
					</template>
          
					<el-menu-item index="" class='topitem' @click.native="openPage('/shownews')"><li class='el-icon-info'></li> News & Messages</el-menu-item>
					<el-menu-item index="" class='topitem' @click.native="logout"><li class='el-icon-platform-eleme'></li> Logout</el-menu-item>

				</el-menu>
				
				<!--Navigatiemenu - Ingeklapt 'hamburger' -->
			
        <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
					<li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
						<template v-if="!item.leaf && canUse(item)" > <!--userRoles.includes(item.role)">-->
							<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)">
                <i :class="item.iconCls"></i>
              </div>
							<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"> 
								<li v-for="child in item.children" v-if="!child.hidden && canUse(child)" :key="child.path" class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}</li>
							</ul>
						</template>
						<template v-else>
							<li class="el-submenu">
								<div class="el-submenu__title el-menu-item" style="padding-left: 10px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
							</li>
						</template>
					</li>
				</ul>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<strong class="title"><i class='el-icon-document'></i> {{$route.name}}</strong>
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>						
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
    


	</el-row>

</template>

<script>
  import util from '../common/AppUtil';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"*"),
        showMiniMenu: false,    // false=mini menu, true=remove!!!

        sysName: process.env.APP_NAME,
        appBuild: window.appbuild,
				collapsed:false,
        userLevel: 0,
        userRoles: 'sys',
        departments: '',
				userToken: '',
        stageClass: 'dev',
        stageSubtitle: '',
				sysUserName: '',
				sysUserAvatar: '',
				form: { }
			}
		},
		methods: {	
      canUse(item) {
        return util.canUse(item.role,item.dept,this.userRoles,this.departments);
        //return this.userRoles.includes(item.role) && this.departments.includes(item.dept);
      },

			onSubmit() {
			},
			
			handleopen() {
			},
						
			handleclose() {
			},
			
			handleselect: function (a, b) {
			},

			openPage: function(link) {
      this.$router.push(link);
      },

      versionInfo: function() {
        if (window.apiserver == undefined)
        {
          return "Startup: " + process.env.APP_NAME;
        }
        else {
          this.sysName = window.appname;
          this.stageClass = window.stage;

          if (window.stage != "prd") this.stageSubtitle = " [" + window.stage.substring(0,1).toUpperCase() + "]";

          return   "App name: " + window.appname + " (" + window.appbuild[0] + ")" 
               + "\nVersion : " + window.appbuild[1]
               + "\nCreated : " + window.appbuild[2]
               + "\nMain API: " + util.getStageUrl(window.apiserver[0])
               ;
        }
      },


			// Uitloggen
			logout: function () {
				var _this = this;
				this.$confirm('Are you sure to leave this session ?', 'Logout', {
          cancelButtonText: "Eh, no",
					confirmButtonText: "Sure",
					type: "warning"  // success, info, warning, error
				}).then(() => {
          sessionStorage.setItem("force","1");
					sessionStorage.removeItem('user');
					_this.$router.push('/login');
				}).catch(() => {

				});
      },
									
			// Vouw navigatiebalk
			collapse:function(){
				this.collapsed=!this.collapsed;
			},
	  	
			showMenu(i,status){			
		    this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			},
		},
    
		mounted() {

      // close menu if total window size < 800px, only on initial load (RN)
      if (window.innerWidth < 800) {
  			this.collapsed=true;
      }
			this.userToken     = sessionStorage.getItem('token');
      this.sysUserAvatar = sessionStorage.getItem('avatar');
			this.sysUserName   = sessionStorage.getItem('name');
			this.sysLogin      = sessionStorage.getItem('login');
			this.userLevel     = sessionStorage.getItem("userLevel");
      this.userRoles     = sessionStorage.getItem('roles');
      this.departments   = sessionStorage.getItem('depts');
    }
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';

	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;

		.el-dropdown {
		  height:55px;
		}
		.header {
			height: 60px;
			line-height: 60px;
			background: $color-primary;
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 15px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				//xwidth:230px;
				height:60px;
				font-size: 16px;
				padding-left:20px;
				padding-right:5px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:230px;
			}
			.logo-collapse-width{  
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 230px;
				width: 230px;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 230px;
				width: 230px;
			}
			.content-container {
				// background: #f1f2f7;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow-y: scroll;
				padding: 5px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}

  @media screen and (max-width: 1024px) {
		.content-container {
				padding: 5px;
		}
		.el-message {top:0}
  }

  div#top-panel {cdisplay:none;padding:0}
  .datahelper{ height:80%;max-height:640px}
  .thumbnail-container{max-height:500px}

  .player {height:30px;width:270px;margin-top:15px;margin-left:10px}

  .dev {background-color:orange}
  .itg {background-color:blue}
  .qua {background-color:green}
  .prd {}
</style>


// WEBPACK FOOTER //
// Home.vue?b35caa98